import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import SearchPage from '..';
import useIsMobile from '../../../components/hooks/useIsMobile';
import { useStatsig } from '../../../components/hooks/useStatsig';
import { useAdDynamicConfig } from '../../../components/hooks/useAdDynamicConfig';

const SearchPageWrapper = (props) => {
    const user = useSelector((state) => state.auth?.user);
    const { initializeStatsigUser } = useStatsig();
    const {
        showAds,
        eventSearchConfig,
        playerSearchConfig,
        clubSearchConfig,
        searchConfig,
    } = useAdDynamicConfig();
    const { isMobileWidth, isTabletWidth } = useIsMobile();

    useEffect(() => {
        if (user) {
            initializeStatsigUser();
        }
    }, [user]);

    return (
        <SearchPage
            showAds={showAds}
            eventSearchConfig={eventSearchConfig}
            playerSearchConfig={playerSearchConfig}
            clubSearchConfig={clubSearchConfig}
            searchConfig={searchConfig}
            isMobileWidth={isMobileWidth}
            isTabletWidth={isTabletWidth}
            {...props}
        />
    );
};

export default SearchPageWrapper;
